import { makeStyles } from '@policygenius/mortar';

export default makeStyles((theme) => ({
  root: {
    margin: [`-${theme.spacing('medium')}`, theme.spacing('medium'), theme.spacing('xlarge')],
    [`@media (min-width: ${theme.breakpoints.medium}px)`]: {
      marginLeft: 'auto',
      marginRight: 'auto',
    },
  },
  learnMore: {
    height: 'unset', // Ensuring the button matches the rest of the text
    outline: 'none',
  },
}));
